<template>
  <div>
    <ul >
      <li class="skeleton_warp" v-for="item in data">
        <div class="first_li">
          <div class="av animation_box"></div>
          <p class="animation_box"></p>
        </div>
        <p class="item animation_box"></p>
        <p class="item animation_box"></p>
        <p class="item animation_box"></p>
        <p class="item animation_box"></p>
      </li>
      
    </ul>
  </div>
    
</template>
<script>
export default {
  name: 'HelloWorld',
  props: {
    data: Number
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.skeleton_warp {
  width: 100%;
  height: 200px;
  background: #ffffff;
  padding:15px; 
  box-sizing: border-box;
  border-bottom: 1px solid #e8e8e8;
  .item{
    height: 7px;
    background: #fffcfc;
    margin-top: 15px;
   
  }
  .av{
    width: 40px;
    height: 40px;
    background: #fffcfc;
    display: inline-block;
    border-radius: 50%;
  }
  .first_li{
    height: 50px;
    display: flex;
    background: #ffffff;
    align-items: center;
    
    >p{
      width: 70px;
      height: 5px;
      background: #fffcfc;
      margin-left:15px;
      margin-bottom:3px;
    }
    
  }
  .animation_box{
      animation: myfirst 1s infinite;
    }

  @keyframes myfirst
  {
  0% {background:#e8e8e8;}

  50% {background: #f0f0f0;}

  100% {background:#e8e8e8;}

  }


}
</style>